import { useContext } from 'react'
import { CubeIcon, ShoppingBagIcon } from '@heroicons/react/24/outline'
import { useTranslation } from 'libs/i18n'

import { routes } from 'config/routes'
import { DashboardList } from './List'
import { DashboardContext } from 'store'
import { RecentlyAddedProduct, RecentlySoldProduct } from '../types/types'

export const DashboardRecentlyAdded = () => {
	const dashboardCtx = useContext(DashboardContext)

	const { t } = useTranslation()

	return (
		<DashboardList
			label={t('Products')}
			title={t('Recently added products')}
			emptyText={t('No recently added products')}
			icon={<CubeIcon />}
			iconBgColor="bg-primary-soft"
			iconColor="text-primary"
			list={dashboardCtx?.dashboard?.recently_added_products as RecentlyAddedProduct[]}
			viewAllTo={routes.productIndex}
		/>
	)
}

export const DashboardRecentlySold = () => {
	const dashboardCtx = useContext(DashboardContext)

	const { t } = useTranslation()

	return (
		<DashboardList
			label={t('Sales')}
			title={t('Recently sold products')}
			emptyText={t('No recently sold products')}
			icon={<ShoppingBagIcon />}
			iconBgColor="bg-muted"
			iconColor="text-muted-foreground"
			list={dashboardCtx?.dashboard?.recently_sold_products as RecentlySoldProduct[]}
			viewAllTo={`${routes.saleIndex}?ordering=-created`}
		/>
	)
}
